import axios from "axios";

export default {
    namespaced: true,
    state: {
        list: null,
        mapSettings: {
            position: null,
            center: null,
            selectedBusinessID: -1,
            fullHeight: false,
        }
    },
    getters: {
        getBusinessById: (state) => (id) => {
            return state.list.find(b => b.business_id === id)
        }
    },
    mutations: {
        setBusinesses(state, val) {
            val.map(el => {
                el.fullAddress = fullAddress.bind(el);
            })
            state.list = val;
        }
    },
    actions: {
        loadBusinesses(store, callback) {
            const group_id = store.rootState.shared.groupId;
            axios.get(`/unauth/groups/${group_id}/businesses`).then(res => {
                let arr = res.data;
                //console.log(arr);
                store.commit("setBusinesses", arr);
                if (!store.state.mapSettings.position && !window.localStorage.getItem("lastPosition")){
                    store.state.mapSettings.center = store.state.mapSettings.position = {lat: Number(arr[0]?.lat), lng: Number(arr[0]?.lon)};
                }else{
                    const savedLastPosition = window.localStorage.getItem("lastPosition");
                    if (savedLastPosition){
                        store.state.mapSettings.center = store.state.mapSettings.position = JSON.parse(savedLastPosition);
                    }
                }
                callback?.(arr)
            })

        },
        initGeoLocation({state}, callback) {
            if (window.navigator.geolocation) {
                window.navigator.geolocation.getCurrentPosition(
                        (position) => {
                            state.mapSettings.center = state.mapSettings.position = {lat: position.coords.latitude, lng: position.coords.longitude};
                            window.localStorage.setItem("lastPosition", JSON.stringify(state.mapSettings.position));
                            callback?.();
                        }
                );
            }
        },
        calcClosest({state}) {
            if (state.list && state.mapSettings.position) {
                const currentPosition = state.mapSettings.position;
                state.list.map(b => {
                    b.distance = calcDistance(currentPosition.lat, currentPosition.lng, b.lat, b.lon).toFixed(1)
                });
                state.list.sort(function (a, b) {
                    return a.distance - b.distance;
                });
            }
        },
    }
}

const fullAddress = function () {
    return this.address1 + ' ' + this.city + ', ' + this.state + ' ' + this.zipcode;
}

const calcDistance = function (lat1, lon1, lat2, lon2, unit) {
    var radlat1 = Math.PI * lat1 / 180;
    var radlat2 = Math.PI * lat2 / 180;
    var theta = lon1 - lon2;
    var radtheta = Math.PI * theta / 180;
    var dist = Math.sin(radlat1) * Math.sin(radlat2) + Math.cos(radlat1) * Math.cos(radlat2) * Math.cos(radtheta);
    dist = Math.acos(dist);
    dist = dist * 180 / Math.PI;
    dist = dist * 60 * 1.1515;
    if (unit == "K") {
        dist = dist * 1.609344;
    }
    if (unit == "N") {
        dist = dist * 0.8684;
    }
    return dist
}
